import { animate, state, style, transition, trigger } from '@angular/animations';

/**
 * Animation for adding a simple fade-in and fade-out.
 *
 * @param durationMS length of the animation
 */
export const fadeInOutAnimation = (durationMS = 200) =>
	trigger('fadeInOut', [
		state('void', style({ opacity: 0 })),
		state('*', style({ opacity: 1 })),
		transition('void <=> *', animate(`${durationMS}ms ease-out`))
	]);
